import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  useDispatch,
  connect,
  useRouter,
  Cookie,
} from "../../../atoms/DependencyHelper";
import {
  CONSENT_CHECK,
  AGREE_CHECK,
  P50_CUST,
} from "../../../../config/constants";
import {
  imagePrefix,
  showSpinner,
  hideSpinner,
  urlPrefix,
  getCookieValue,
  africaCountryCode,
  appendCountryCode,
  generateFormURL,
  titleCaseFirstLetterOfString,
  getOrderCreated,
  setCookieConsentWrapper,
  getDateOfBirth,
} from "../../../../utils/helperServices";
import {
  Features,
} from "../../../../utils/featuresService";
import {
  ADD_CREDIT_PROFILE,
  SET_CREDIT_CHECK_AFFORD_DEAL,
  SET_CREDIT_VETTING_OUTCOME,
  SET_SKIP_CREDIT_VETTING,
  SET_CREDIT_VETTING_RESULT,
} from "../../../../Redux/actionTypes/index";
import { removeCreditCheckStates } from "../../../../Redux/actions/checkoutAction";
import { deleteItemsFromCart } from "../../../../Redux/actions/cartAction";
import ConsentResultsForm from "../../../atoms/newLineForms/creditCheckForms/consentResultsForm/ConsentResultsForm";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import microService from "../../../../utils/microServices";
import ajaxService from "../../../../utils/ajaxServices";
import labels from "../../../../config/labels";
import styles from "../CheckoutCreditCheck.module.scss";
import * as Analytics from "../../../../services/analyticsUtag";
import { journeyType } from "../../../../context/checkout-journey-context";
import {
  setPaymentMethod,
  setShippingMethodsOnCartService,
} from "../../../../services/checkoutService";
import { productOrderReq } from "../../../../data/mockRenderComponent";
import config from "../../../../config/index";
import axios from "axios";

import {
  Logger,
} from "../../../../utils/logger";

/**
 * Consent Details component holds the logic of consent and result detail form validation logic,
 * handling all the API calls and analytics
 */
const ConsentResultDetails = ({
  type,
  userLoggedIn,
  profileData,
  customerStatus,
  onFormSubmit,
  debitDetailsData,
  personalDetailsData,
  employmentDetailsData,
  contactDetailsData,
  homeDetailsData,
  deliveryDetailsData,
  authDetailsData,
  setPageErr,
  navigate,
  setCreditOutcome,
  continueDisable,
  creditFilters,
  cartProducts,
  dealCategoryId,
  setShowDocsData,
  setShowOfflineData,
  currentJourneyType,
  removeCreditCheckStates,
  isDoCreditCheckDisable,
  deleteItemsFromCart,
  cartDetails,
  carrierCode,
  methodCode,
  multicartFlag,
  setShowOnceOff,
  selectedPreference,
  selectedUpgradeResponse,
}) => {
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [formContent, setFormContent] = useState(null);
  const otpAuthtoken = getCookieValue("vod-web-auth-otp-token");
  const [dealName, setDealName] = useState("");
  const [state, setState] = useState({
    validationsOn: {
      consentResultDetails: true,
    },
    errorStatus: {
      consentResultDetails: true,
    },
    validations: {
      consentResultDetails: {
        consentCheck0: true,
        consentCheck1: true,
      },
    },
    fieldErrors: {
      consentResultDetails: {
        consentCheck0: false,
        consentCheck1: false,
      },
      fail: false,
    },
    fieldValues: {
      consentResultDetails: {
        consentCheck0: false,
        consentCheck1: false,
      },
    },
    fieldErrorsMessage: {
      consentResultDetails: {},
    },
  });
  const dispatch = useDispatch();
  const router = useRouter();
  const { fieldValues } = state;
  const declined_lead_next_level_multicart = "Declined_LeadNXT_LVL_Multicart";

  /**
   *Get the consent form content from the drupal API
   *Reformatting the Year and Month data on page load
   */
  useEffect(() => {
    fetchFormContent();
  }, [homeDetailsData, debitDetailsData]);

  /**
   *This function is used to restructure the date format(YYYY-MM-DD)
   */
  const reStructuredDatOfBirth = (date) => {
    let updatedDate;
    if (date) {
      let year = date.slice(6, 10);
      let month = date.slice(3, 5);
      let day = date.slice(0, 2);
      updatedDate = year + "-" + month + "-" + day;
    } else {
      updatedDate = "";
    }
    return updatedDate;
  };

  const mmddyyyyDateFormat = (date) => {
    let updatedDate;
    if (date) {
      let newDate = date.replace(/\s/g, "");
      var values = newDate.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });
      updatedDate = values[1] + "/" + values[0] + "/" + values[2];
    } else {
      updatedDate = "";
    }
    return updatedDate;
  };

  const createCustDobFormat = () => {
    if (personalDetailsData?.dob) {
      let dob = personalDetailsData?.dob.replace(/\s/g, "");
      var values = dob.split("/").map(function (v) {
        return v.replace(/\D/g, "");
      });
      return values[1] + "/" + values[0] + "/" + values[2];
    }
  };

  /**
   *This function is used to remove starting digit from the string
   */
  const reStructuredTypeOfAccount = (accountType) => {
    return accountType.substring(accountType.indexOf("-") + 1);
  };

  /**
   *This function is used to remove "R" and special characters from the number
   */
  const reStructuredSalary = (salary) => {
    let amount = salary.replace(/\n|\R/g, "");
    return Math.ceil(amount.replace(/,/g, "")).toString();
  };

  /**
   *This function is used to replace the "27" code with "0" from the phone number
   */
  const reStructuredPhoneNumber = () => {
    let phoneNumber;
    if (contactDetailsData?.cellNumber.slice(0, 2) === "27") {
      phoneNumber = contactDetailsData?.cellNumber.replace(/^.{2}/g, "0");
    } else {
      phoneNumber = contactDetailsData?.cellNumber;
    }
    return phoneNumber;
  };

  const getTitle = (str) => {
    switch (str) {
      case "Dr.":
        return "DR";
      case "Prof":
        return "Prof";
      default:
        return str.toUpperCase();
        break;
    }
  };

  const dealCartProduct = cartProducts.find(
    (cartProduct) =>
      cartProduct?.product?.is_deal_product === 1 &&
      cartProduct?.product?.__typename === labels.lbl_product_type_bundle
  );
  const cartId = getCookieValue("cart_id");
  const cartProductId = dealCartProduct?.id;

  const totalZero =
    parseFloat(cartDetails?.shippingFeeCalculate?.shipping_fee) +
      parseFloat(cartDetails?.prices?.grand_total?.value) ==
    parseFloat(0)
      ? "true"
      : "false";

  const authToken = getCookieValue("auth_token");
  const vodAuthToken = getCookieValue("vod-web-auth-token");

  /** Get form content from the drupal api
   * Redirect user to the generic error code page if drupal api gets failed
   */
  const fetchFormContent = async () => {
    showSpinner();
    try {
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "creditCheckConsent"
      );
      if (result?.sections[0]?.items) {
        setFormContent(result.sections[0].items);
        hideSpinner();
      } else {
        fetchErrorDetails(
          labels.creditVetting.lbl_form_content_not_found,
          "technical error",
          null,
          labels.checkout.lbl_preference_values
        );
      }
    } catch (e) {

      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "fetchFormContent"
        }
      );

      hideSpinner();
      fetchErrorDetails(
        labels.creditVetting.lbl_form_content_not_found,
        "technical error",
        null,
        labels.checkout.lbl_preference_values
      );
    } finally {
      hideSpinner();
    }
  };

  /**
   * Form input field change event handler
   *
   * @usage Enable or disable form submit button
   * @call onChange event
   */
  const handleChange = async (event, form) => {
    let name = event.target.name;
    let value = event.target.checked;
    fieldValues[form][name] = value;
    setState({
      ...state,
      fieldValues,
    });
    if (name === CONSENT_CHECK && value) {
      setAnalyticsOnconsentcheck(labels.creditVetting.lbl_chk_consent);
    } else if (name === AGREE_CHECK && value) {
      setAnalyticsOnconsentcheck(labels.creditVetting.lbl_chk_agree);
    }
    if (fieldValues[form][CONSENT_CHECK] && fieldValues[form][AGREE_CHECK]) {
      setSubmitDisabled(false);
    } else {
      setSubmitDisabled(true);
    }
  };

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    setAnalyticsOnDoCreditCheck();
    currentJourneyType === journeyType.newLine
      ? submitForm()
      : submitAddLineForm();
  };

  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */
  const mapAddLineFieldData = () => {
    const dealProduct = cartProducts.find(
      (cartProduct) =>
        cartProduct?.product?.is_deal_product === 1 &&
        cartProduct?.product?.__typename === labels.lbl_product_type_bundle
    );

    const dealSku = dealProduct?.product?.sku;

    return {
      context:
        currentJourneyType === journeyType.addLine ? "ADDLINE" : "UPGRADE",
      dealSheetId: dealSku,
      idNumber: authDetailsData?.idNumber,
      idType: authDetailsData?.idType,
      updateAddressDetails: {
        inputType: "ADDRESS",
        addressType: "Residential",
        addressDetails: {
          addressType: homeDetailsData?.addressType,
          buildingName: "",
          city: homeDetailsData.town,
          complexName: homeDetailsData?.complexName,
          complexNumber: "",
          complexStreet: "",
          country: "South Africa",
          deliveryAddressFlag: "true",
          lineOne: "",
          postalCode: homeDetailsData?.postalCode,
          postalDeliveryFlag: "false",
          primaryAddressFlag: "false",
          privateBagNumber: "",
          province: homeDetailsData?.provinceName,
          ricaFlag: "false",
          seoid: "",
          streetName: homeDetailsData?.streetName,
          streetNo: homeDetailsData?.streetNo
            ? homeDetailsData?.streetNo
            : "00",
          suburb: homeDetailsData?.suburb,
          unitNumber: homeDetailsData?.unitNo,
        },
      },
      otpToken: otpAuthtoken,
    };
  };

  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */
  const submitAddLineForm = async () => {
    let inputObj = mapAddLineFieldData();

    if (Features.get("simOnlyEarlyUpgradeEnabled") && inputObj?.context === "UPGRADE"){
      inputObj.simOnlyUpgradeFlg = selectedUpgradeResponse?.simOnlyUpgradeFlg;
    }

    setCreditOutcome({
      visible: true,
      title: "",
      desc: multicartFlag
        ? labels.creditVetting.lbl_loading_screen_msg_multicart
        : labels.creditVetting.lbl_loading_screen_msg,
      screenType: "loadingScreen",
    });
    try {
      let responseData = await microService.put(
        "api",
        "customerDetails",
        inputObj,
        null,
        true
      );
      if (responseData?.response?.data) {
        getCreditVettingOutcomeResult(responseData.response.data);
      } else {
        if (responseData?.error?.status) {
          fetchErrorDetails(
            `updateCustomerDetails_${responseData.error.status}`,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        } else {
          fetchErrorDetails(
            labels.auth.errorCodes.api_time_out,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      }
    } catch (error) {

      Logger.error(
        error,
        "ConsentResultDetails",
        {
          function: "submitAddLineForm"
        }
      );
    }
  };

  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */
  const submitForm = async () => {
    let inputObj = mapFieldData();
    let reqParams = [authDetailsData?.idNumber];
    setCreditOutcome({
      visible: true,
      title: "",
      desc: multicartFlag
        ? labels.creditVetting.lbl_loading_screen_msg_multicart
        : labels.creditVetting.lbl_loading_screen_msg,
      screenType: "loadingScreen",
    });
    try {
      let responseData = await microService.post(
        "api",
        "createCustomer",
        inputObj,
        null,
        false,
        reqParams
      );
      if (responseData?.response?.data?.result) {
        getCreditVettingOutcomeResult(responseData.response.data.result);
      } else {
        if (responseData?.error?.status) {
          fetchErrorDetails(
            `createCustomer_${responseData.error.status}`,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        } else {
          fetchErrorDetails(
            labels.auth.errorCodes.api_time_out,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      }
    } catch (e) {
      
      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "submitForm"
        }
      );
    }
  };

  /**
   * Credit vetting outcome api call
   * Call credit vetting outcome api if new customer gets created
   * @usage submit the credit vetting outcome request payload
   */
  const getCreditVettingOutcomeResult = async (customerInfo) => {
    let inputObj =
      currentJourneyType === journeyType.newLine
        ? getCreditVettingOutComePayload(customerInfo)
        : getCreditVettingOutComeAddLinePayload(customerInfo);
    let drupalBasedResult, idType, dateOfBirth;
    dateOfBirth = personalDetailsData?.dob
      ? getDateOfBirth(personalDetailsData?.dob)
      : "";
    idType = authDetailsData?.idType;

    try {
      const creditVettingResponse = await microService.post(
        "api",
        "creditVettingOutcome",
        inputObj,
        null,
        false
      );
      const creditVettingResult = creditVettingResponse?.response?.data?.result;

      dispatch({
        type: SET_CREDIT_VETTING_RESULT,
        payload: creditVettingResult,
      });
      if (creditVettingResult) {
        let applicationStatus =
          creditVettingResult.vettingOutcome?.vettingSummary?.applicationStatus;
        let vettingStatus =
          creditVettingResult.vettingOutcome?.vettingSummary?.vettingStatus;
        let resultCode = creditVettingResult?.resultCode;

        if (
          (vettingStatus === labels.creditVetting.lbl_pended  ||
          vettingStatus === labels.creditVetting.lbl_pending  ||
          vettingStatus === labels.creditVetting.lbl_referred ||
          vettingStatus === labels.creditVetting.lbl_declined) &&
          applicationStatus === labels.creditVetting.lbl_processed && 
          (resultCode === labels.creditVetting.lbl_resultcode_declined ||
          resultCode === labels.creditVetting.lbl_resultcode_pended    ||
          resultCode === labels.creditVetting.lbl_resultcode_pending   ||
          resultCode === labels.creditVetting.lbl_resultcode_referred) &&
          idType === "SAID" &&
          Number(dateOfBirth) > 25
        ) {
          if (multicartFlag) {
            fetchErrorDetails(
              labels.creditVetting.lbl_declined_passport,
              "declined passport",
              null
            );
          } else {
            await placeOrder();

            if(resultCode != labels.creditVetting.lbl_resultcode_declined){
              await createSalesLead();
            } 

            declinedPassportDetails(resultCode);
          }
        } else if (
          vettingStatus === labels.creditVetting.lbl_declined &&
          applicationStatus === labels.creditVetting.lbl_processed &&
          resultCode === labels.creditVetting.lbl_resultcode_declined_nxtlvl &&
          idType === "SAID" &&
          Number(dateOfBirth) >= 18 &&
          Number(dateOfBirth) <= 25
        ) {
          if (!multicartFlag) {
            await placeOrder(); 
          }
           
          declinedSAIDDetails(
            labels.creditVetting.lbl_declined_non_nxtlvl,
            null,
            null,
            labels.checkout.lbl_preference_values
          );
        } else if (
          (vettingStatus === labels.creditVetting.lbl_pended  ||
          vettingStatus === labels.creditVetting.lbl_pending  ||
          vettingStatus === labels.creditVetting.lbl_referred ||
          vettingStatus === labels.creditVetting.lbl_declined) &&
          applicationStatus === labels.creditVetting.lbl_processed &&
          (resultCode === labels.creditVetting.lbl_resultcode_declined ||
          resultCode === labels.creditVetting.lbl_resultcode_pended    ||
          resultCode === labels.creditVetting.lbl_resultcode_pending   ||
          resultCode === labels.creditVetting.lbl_resultcode_referred) &&
          idType === "PASSPORT"
        ) {
          if (multicartFlag) {
            fetchErrorDetails(
              labels.creditVetting.lbl_declined_passport,
              "declined passport",
              null
            );
          } else {
            await placeOrder();

            if(resultCode != labels.creditVetting.lbl_resultcode_declined){
              await createSalesLead();
            } 
            
            declinedPassportDetails(resultCode);
          }
        } else if (
          resultCode === labels.creditVetting.lbl_resultcode_pended ||
          resultCode === labels.creditVetting.lbl_resultcode_pending ||
          resultCode === labels.creditVetting.lbl_resultcode_referred
        ) {            
          await placeOrder();
          await createSalesLead();

          fetchErrorDetails(
            ((resultCode === labels.creditVetting.lbl_resultcode_referred)
            ?labels.creditVetting.lbl_referred_non_nxtlvl
            :labels.creditVetting.lbl_pending_non_nxtlvl),
            ((resultCode === labels.creditVetting.lbl_resultcode_referred)
            ?"referred ID / Passport"
            :"pending Id / Passport"),
            null
          );
        } else if (
          applicationStatus === labels.creditVetting.lbl_processed &&
          vettingStatus ===
            labels.creditVetting.lbl_approved_with_condition_status &&
          resultCode ===
            labels.creditVetting.lbl_resultcode_approved_with_condition
        ) {
          if (
            creditVettingResult?.vettingOutcome.vettingSummary.portfolio ===
            P50_CUST
          ) {
            fetchCreditVettingErrorDetails(
              labels.creditVetting.code_p50_affordability,
              labels.creditVetting.lbl_p50_error_code,
              "",
              null,
              null
            );
          } else {
            let creditFilterData = creditVettingResult.creditFilter;
            const creditFiltersValue = {
              total_monthly_payment: creditFilterData.affordability,
              financeIndicator: creditFilterData.creditFilters.financeIndicator,
              deviceInstallment:
                creditFilterData.creditFilters.deviceInstallment,
            };
            dispatch({
              type: ADD_CREDIT_PROFILE,
              payload: creditFiltersValue,
            });
            dispatch({
              type: SET_SKIP_CREDIT_VETTING,
              payload: true,
            });
            dispatch({
              type: SET_CREDIT_CHECK_AFFORD_DEAL,
              payload: true,
            });
            fetchCreditVettingErrorDetails(
              labels.creditVetting.code_approved_with_condition,
              labels.creditVetting.lbl_approved_with_condition,
              creditFiltersValue,
              null,
              null,
              labels.checkout.lbl_preference_approved_conditions_values
            );
          }
        } else if (
          applicationStatus === labels.creditVetting.lbl_processed &&
          vettingStatus === labels.creditVetting.lbl_approved &&
          resultCode === labels.creditVetting.lbl_resultcode_approved
        ) {
          continueDisable(false);
          getApprovedScreencontent(labels.creditVetting.lbl_code_approved);
        } else if (
          resultCode === labels.creditVetting.lbl_resultcode_offline ||
          applicationStatus === labels.creditVetting.lbl_unprocessed
        ) {
          drupalBasedResult = await offlineVettingContent();
          setCreditOutcome({
            visible: true,
            title: drupalBasedResult[0]?.resultTitle,
            desc: drupalBasedResult[0]?.resultText,
            screenType: resultCode,
            iconType: drupalBasedResult[0]?.icon,
          });
          dispatch({
            type: SET_CREDIT_VETTING_OUTCOME,
            payload: drupalBasedResult[0],
          });
          continueDisable(false);
          setShowOfflineData(true);
        } else {
          fetchErrorDetails(
            `${
              creditVettingResponse?.error?.status
                ? "creditVettingOutcome_" + creditVettingResponse.error.status
                : "creditVettingOutcome_424"
            }`,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      } else {
        if (creditVettingResponse?.error?.status) {
          fetchErrorDetails(
            `creditVettingOutcome_${creditVettingResponse.error.status}`,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        } else {
          fetchErrorDetails(
            labels.auth.errorCodes.api_time_out,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      }
    } catch (e) {

      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "getCreditVettingOutcomeResult"
        }
      );

      fetchErrorDetails(
        labels.auth.errorCodes.api_time_out,
        "technical error",
        null
      );
    }
  };
 
  const createSalesLead = async () =>{
    try { 
      // When creditCheckDetails.personalDetails is null then check firstname and lastname ongit 
      // the cartDetails.billing_address and cartDetails.shipping_address
      // and cartDetails.navDetails.profileData
      // name and surname are required.
      const firstname = personalDetailsData?.firstName ? personalDetailsData?.firstName 
                      :cartDetails?.billing_address?.firstname?cartDetails?.billing_address?.firstname
                      :cartDetails?.shipping_address?.firstname?cartDetails?.shipping_address?.firstname
                      :cartDetails?.navDetails?.profileData?.firstname?cartDetails?.navDetails?.profileData?.firstname:"";
      const lastname = personalDetailsData?.lastname ? personalDetailsData?.lastname 
                      :cartDetails?.billing_address?.lastname?cartDetails?.billing_address?.lastname
                      :cartDetails?.shipping_address?.lastname?cartDetails?.shipping_address?.lastname
                      :cartDetails?.navDetails?.profileData?.lastname?cartDetails?.navDetails?.profileData?.lastname:"";
 
      const createSalesLeadFormPayload = {
        channel: "ONLINE",
        requestType: "credit_vetting",
        idNumber: africaCountryCode(authDetailsData?.msisdn) ? authDetailsData?.msisdn : appendCountryCode(authDetailsData?.msisdn),
        idDocType: "MSISDN",
        name:  firstname,
        surname: lastname,
        msisdn: africaCountryCode(authDetailsData?.msisdn) ? authDetailsData?.msisdn : appendCountryCode(authDetailsData?.msisdn),
        emailAddress: contactDetailsData?.emailAddress ? contactDetailsData?.emailAddress :""
      }; 
      const salesLeadResponse = await microService.post(
        "api",
        "staticFormSubmit" ,
        createSalesLeadFormPayload, 
        null, 
        false
      ); 
    } catch (error) { 
      // no need to set error if posible error happended -sleep in silent

      Logger.error(
        error,
        "ConsentResultDetails",
        {
          function: "createSalesLead"
        }
      );
    } 
  }

  const declinedPassportDetails = async (resultCode = "") => {
    const pageName = `checkout: credit check: ${customerStatus}: declined`;
    const label = "exit";
    try {
      showSpinner();

      let DrupalCodeContent = labels.creditVetting.lbl_declined_passport; 
      if(resultCode === labels.creditVetting.lbl_resultcode_pended ||
        resultCode === labels.creditVetting.lbl_resultcode_pending ||
        resultCode === labels.creditVetting.lbl_resultcode_referred){
          DrupalCodeContent =(resultCode === labels.creditVetting.lbl_resultcode_referred)
          ?labels.creditVetting.lbl_referred_non_nxtlvl
          :labels.creditVetting.lbl_pending_non_nxtlvl;
      }
      
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [DrupalCodeContent]
      );

      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: () =>
          handleSecondaryClick(result[0].primaryCTAURL, pageName, label),
        imgUrl: result[0].icon,
        pageName,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch {
      setPageErr({
        type: "error",
        title: labels.auth.lbl_technical_error_title,
        desc: labels.auth.lbl_technical_error_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(),
        handleSecondaryClick: () => handleSecondaryClick(),
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: `checkout: credit check: ${customerStatus}: declined`,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  const placeOrder = async () => {
    try {
      showSpinner();
      let shippingMethodData = await setShippingMethodsOnCartService(
        cartId,
        carrierCode,
        methodCode
      );
      if (!shippingMethodData.fail) {
        let paymentMethodData = await setPaymentMethod(cartId, totalZero);
        if (!paymentMethodData.fail) {
          orderRouter();
        } else {
          hideSpinner();
        }
      } else {
        hideSpinner();
      }
    } catch(error) {

      hideSpinner();

      Logger.error(
        error,
        "ConsentResultDetails",
        {
          function: "placeOrder"
        }
      );
    }
  };

  const orderRouter = () => {
    let headers = {};
    let postOrder = JSON.parse(
      JSON.stringify(productOrderReq).replace(/\:null/gi, ':""')
    ); //replace null with "" for all attributes
    postOrder.productOrder[0].externalId = cartId;
    postOrder.productOrder[0].journeyType = currentJourneyType;
    postOrder.productOrder[0].contact.identificationID =
      authDetailsData?.idNumber;
    postOrder.productOrder[0].contact.identificationType =
      authDetailsData?.idType;

    if (vodAuthToken) {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-auth-jwt": `Bearer ${vodAuthToken}`,
        "x-magento-token": `Bearer ${authToken}`,
      };
    } else {
      headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
    }

    const url = `${config.envConfigs[config.env].dxl.url}${
      config["api"]["postpaidProductOrder"]
    }`;

    axios
      .post(url, postOrder, {
        headers: headers,
      })
      .then((response) => {
        if (response.data && response.data.productOrders[0]) {
          setCookieConsentWrapper(
            `cookie_${config.order_id}`,
            [config.cookie_category.strictly_necessary],
            `document.cookie='${config.order_id}=${response.data.productOrders[0].productOrderId};path=/'`
          );

          let newCartId = response?.data?.productOrders[0]?.newCartId;
          if (newCartId) {
            setCookieConsentWrapper(
              "cart_id",
              [config.cookie_category.strictly_necessary],
              `document.cookie='cart_id=${newCartId};path=/'`
            );
          } else {
            Cookie.remove("cart_id");
          }
          hideSpinner();
        } else {
          hideSpinner();
        }
      })
      .catch((err) => {

        hideSpinner();
        checkOrderCreation(err);

        Logger.error(
          err,
          "ConsentResultDetails",
          {
            function: "orderRouter"
          }
        );
      });
  };

  function checkOrderCreation(result) {
    if (result.messages) {
      let len = result.messages.length;
      for (let i = 0; i < len; i++) {
        if (
          result.messages[i].key == "orderStatus" &&
          getOrderCreated(result.messages[i].message)
        ) {
          Cookie.remove("cart_id");
        }
      }
    }
  }

  const offlineVettingContent = async () => {
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "UnprocessedVettingResult"
    );
    return result;
  };

  const leadSubmissonContent = async (resultCode) => {
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;
    const result = await ajaxService.httpGet(
      "drupalBaseUrl",
      "",
      "api",
      "errorResultDetails",
      [newResultCode]
    );
    return result;
  };

  const declinedSAIDDetails = async (
    resultCode,
    pageErrorType,
    additionalUtagData = null,
    preferences = []
  ) => {
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;
    let pageName = `checkout: credit check: ${customerStatus}: nxt lvl`;
    // let primaryLabel = "call me";
    // let secondaryLabel = "exit";
    try {
      showSpinner();
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [newResultCode]
      );
      if (multicartFlag) {
        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          desc:
            result[0].resultText && result[0].resultText !== ""
              ? result[0].resultText
              : result[0].resultHTML,
          subDesc:
            result[0].resultHTML && result[0].resultHTML !== ""
              ? result[0].resultHTML
              : null,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          dividerLine: multicartFlag ? true : false,
          handlePrimaryClick: (preferenceId) =>
            result[0].resultCode === declined_lead_next_level_multicart &&
            preferenceId === "call-me-back"
              ? handlePrimaryNxtLvlClick(
                  pageName,
                  result[0].primaryCTAText,
                  result[0].leadType
                )
              : handlePrimaryClick(
                  generateFormURL(
                    result[0].primaryCTAURL,
                    result[0].leadType,
                    result[0].primaryCTAType,
                    preferenceId
                  ),
                  result[0].primaryCTAText
                ),
          handleSecondaryClick: () =>
            handleSecondaryClick(
              result[0].secondaryCTAURL,
              pageName,
              result[0].secondaryCTAText,
            ),
          imgUrl: result[0].icon,
          pageName: pageName,
          pageErrorType: pageErrorType,
          additionalUtagData: additionalUtagData,
          ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
          disablePrimary:
            multicartFlag && preferences.length > 0 ? true : false,
          preferences: multicartFlag ? preferences : [],
          defaultPreference:
            multicartFlag && result[0].primaryCTAURL?.includes("/checkout")
              ? "once-off"
              : null,
        });
      } else {
        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          subDesc:
            result[0].resultText && result[0].resultText !== ""
              ? result[0].resultText
              : null,
          subTitle: result[0].resultHTML ? result[0].resultHTML : null,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          dividerLine: true,
          handlePrimaryClick: () =>
            handlePrimaryNxtLvlClick(
              pageName,
              result[0].primaryCTAText,
              result[0].leadType
            ),
          handleSecondaryClick: () =>
            handleSecondaryClick(
              result[0].secondaryCTAURL,
              pageName,
              result[0].secondaryCTAText
            ),
          imgUrl: result[0].icon,
          pageName,
        });
      }
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch (err) {

      Logger.error(
        err,
        "ConsentResultDetails",
        {
          function: "declinedSAIDDetails"
        }
      );

      setPageErr({
        type: "error",
        title: labels.auth.lbl_technical_error_title,
        desc: labels.auth.lbl_technical_error_desc,
        primaryLabel: "Call me back",
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(null, null, pageName, primaryLabel),
        handleSecondaryClick: () => handleSecondaryClick(null, pageName, secondaryLabel),
        imgUrl: `${imagePrefix}/assets/images/info-s-copy.svg`,
        pageName: pageName,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  /**
   * Credit vetting outcome request payload
   *
   * @usage map the key-value pair request
   */
  const getCreditVettingOutComePayload = (customerInfo) => {
    const dealProduct = cartProducts?.find(
      (cartProduct) =>
        cartProduct?.product?.is_deal_product === 1 &&
        cartProduct?.product?.__typename === labels.lbl_product_type_bundle
    );
    const dealPrice = dealProduct?.product?.monthly_recurring.toString();
    const dealSku = dealProduct?.product?.sku;
    const eppixproductcode = dealProduct?.product?.eppixproductcode
      ? dealProduct.product.eppixproductcode
      : "0";
    setDealName(dealProduct?.product?.name);
    return {
      journeyType: "Newline",
      creditVettingPayload: {
        bankingDetails: {
          bankAccountType: reStructuredTypeOfAccount(
            debitDetailsData?.accountType
          ),
          salaryDay: employmentDetailsData?.salaryDate,
          accountHolder:
            personalDetailsData?.firstName + " " + personalDetailsData?.surName,
          accountNumber: debitDetailsData?.accountNumber,
          branchName: debitDetailsData?.branchName
            ? debitDetailsData.branchName
            : "Universal",
          bankName: debitDetailsData?.bank,
          branchCode: debitDetailsData?.branchCode
            ? debitDetailsData.branchCode
            : "",
          debiCheckFlag: debitDetailsData?.debiCheckFlag,
          ageOfAccount: {
            years: debitDetailsData.ageOfAccountYears
              ? Number(debitDetailsData.ageOfAccountYears.replace(/\D/g, ""))
              : 0,
            months: debitDetailsData.ageOfAccountMonths
              ? Number(debitDetailsData.ageOfAccountMonths.replace(/\D/g, ""))
              : 0,
          },
        },
        contactDetails: {
          residentialAddressDetails: {
            residence: homeDetailsData?.residence,
            streetNumberName: homeDetailsData?.streetName,
            suburb: homeDetailsData?.suburb,
            townCity: homeDetailsData?.town,
            postalCode: homeDetailsData?.postalCode,
            periodAtCurrentAddress: {
              years: Number(
                homeDetailsData?.currentAddressYears
                  ? homeDetailsData.currentAddressYears.replace(/\D/g, "")
                  : "00"
              ),
              months: Number(
                homeDetailsData?.currentAddressMonths
                  ? homeDetailsData.currentAddressMonths.replace(/\D/g, "")
                  : "00"
              ),
            },
            periodAtPreviousAddress: {
              years: Number(
                homeDetailsData?.previousAddressYears
                  ? homeDetailsData.previousAddressYears.replace(/\D/g, "")
                  : "00"
              ),
              months: Number(
                homeDetailsData?.previousAddressMonths
                  ? homeDetailsData.previousAddressMonths.replace(/\D/g, "")
                  : "00"
              ),
            },
          },
          postalAddressDetails: {
            addressLine1: deliveryDetailsData?.address?.addressLine1
              ? deliveryDetailsData?.address?.addressLine1
              : "",
            suburb: deliveryDetailsData?.address?.suburb,
            townCity: deliveryDetailsData?.address?.town,
          },
          postalCode: homeDetailsData?.postalCode,
          contactNumbers: {
            mobileNumber: reStructuredPhoneNumber(),
          },
          emailAddress: contactDetailsData?.emailAddress,
        },
        customerDetails: {
          title: getTitle(personalDetailsData?.title),
          initials: personalDetailsData?.initials,
          firstName: personalDetailsData?.firstName
            ? personalDetailsData.firstName
            : "",
          surname: personalDetailsData?.surName
            ? personalDetailsData.surName
            : "",
          idType: authDetailsData?.idType,
          idPassportNumber: authDetailsData?.idNumber
            ? authDetailsData.idNumber.toString()
            : "",
          passportExpiryDate: authDetailsData?.passportExpiry
            ? reStructuredDatOfBirth(
                authDetailsData?.passportExpiry?.replace(/\s/g, "")
              )
            : "",
          countryOfOrigin: authDetailsData?.countryOrigin
            ? authDetailsData?.countryOrigin.split("-").pop()
            : "",
          dateOfBirth: personalDetailsData?.dob
            ? reStructuredDatOfBirth(
                personalDetailsData?.dob.replace(/\s/g, "")
              )
            : "",
          gender: personalDetailsData?.gender === "male" ? "M" : "F",
          maritalStatus: personalDetailsData?.maritalStatus,
          accountNumber: customerInfo?.accountNumber,
        },
        deliveryDetails: {
          building: deliveryDetailsData?.address?.complexName
            ? deliveryDetailsData?.address?.complexName
            : "",
          physicalAddress: deliveryDetailsData?.address?.addressLine1,
          physicalCode: deliveryDetailsData?.address?.postalCode,
          province: homeDetailsData?.provinceName,
          shoppingCenter: "",
          streetName: deliveryDetailsData?.address?.streetName,
          streetNumber: deliveryDetailsData?.address?.streetNo
            ? deliveryDetailsData.address.streetNo
            : "00",
          suburb: deliveryDetailsData?.address?.suburb,
          unitSuitFloor: deliveryDetailsData?.address?.unitNo,
        },
        employmentDetails: {
          occupationCode: employmentDetailsData?.employmentCategory,
          employerName: employmentDetailsData?.employerName,
          monthlyIncome: employmentDetailsData?.grossMonthlySalary
            ? reStructuredSalary(employmentDetailsData?.grossMonthlySalary)
            : "",
          occupation: employmentDetailsData?.empIndustry,
          employmentCategoryCode: employmentDetailsData?.employmentType,
          salaryFrequency: "Monthly",
        },
        otherDetails: {
          userId: customerInfo?.accountId,
          accountID: customerInfo?.accountNumber,
          dealID: dealSku,
          dealCost: dealPrice,
          dealSheetId: dealSku,
          dealSheetNumber: dealSku,
          portInReason: "",
          addressID: customerInfo?.primaryAddressID,
          vasCode: " ",
          vasList: [
            {
              reasonCodeList: {
                reasonCode: [
                  {
                    code: "",
                    description: "",
                  },
                ],
              },
            },
          ],
          billingProfileID: customerInfo.billingProfileId,
          contractCoverFlag: "",
          tarrifCode: eppixproductcode,
        },
      },
    };
  };

  /**
   * Credit vetting outcome request payload
   *
   * @usage map the key-value pair request
   */
  const getCreditVettingOutComeAddLinePayload = (customerInfo) => {
    const dealProduct = cartProducts.find(
      (cartProduct) =>
        cartProduct?.product?.is_deal_product === 1 &&
        cartProduct?.product?.__typename === labels.lbl_product_type_bundle
    );

    const dealPrice = dealProduct?.product?.monthly_recurring.toString();
    const dealSku = dealProduct?.product?.sku;
    const eppixproductcode = dealProduct?.product?.eppixproductcode
      ? dealProduct.product.eppixproductcode
      : "0";

    return {
      journeyType: "Addline",
      creditVettingPayload: {
        applicationDetails: {
          applicantContactNumber: reStructuredPhoneNumber(),
        },
        customerDetails: {
          idType: authDetailsData?.idType,
          idPassportNumber: authDetailsData?.idNumber
            ? authDetailsData.idNumber.toString()
            : "",
          monthlyIncome: employmentDetailsData?.grossMonthlySalary
            ? reStructuredSalary(employmentDetailsData?.grossMonthlySalary)
            : "",
          mobileNumber: reStructuredPhoneNumber(),
        },
        deliveryDetails: {
          streetName: deliveryDetailsData?.address?.streetName,
          streetNumber: deliveryDetailsData?.address?.streetNo,
          suburb: deliveryDetailsData?.address?.suburb,
        },
        otherDetails: {
          userId: customerInfo?.accountId,
          accountID: customerInfo?.accountNumber,
          dealID: dealSku,
          dealCost: dealPrice,
          dealSheetId: dealSku,
          dealSheetNumber: dealSku,
          portInReason: "",
          addressID: customerInfo?.addressId,
          vasCode: "ROH",
          vasList: [
            {
              reasonCodeList: {
                reasonCode: [
                  {
                    code: "",
                    description: "",
                  },
                ],
              },
            },
          ],
          billingProfileID: customerInfo.billingProfileId,
          contractCoverFlag: "",
          tarrifCode: eppixproductcode,
          debiCheckFlag: "N",
        },
      },
      otpToken: otpAuthtoken,
    };
  };

  const getApprovedScreencontent = async (resultCode) => {
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;
    try {
      showSpinner();
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [newResultCode]
      );
      setCreditOutcome({
        visible: true,
        title: result[0]?.resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        screenType: result[0]?.resultCode,
        iconType: result[0]?.icon,
      });
      dispatch({
        type: SET_CREDIT_VETTING_OUTCOME,
        payload: result[0],
      });
    } catch (e) {

      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "getApprovedScreencontent"
        }
      );

      hideSpinner();
      fetchErrorDetails(
        "contentNotFound",
        "technical error",
        null,
        labels.checkout.lbl_preference_values
      );
    } finally {
      hideSpinner();
    }
  };

  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */
  const fetchErrorDetails = async (
    resultCode,
    pageErrorType,
    additionalUtagData = null,
    preferences = []
  ) => {
    const pageName = `checkout: credit check: ${customerStatus}`;
    const label = "";
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;

    try {
      showSpinner();

      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [newResultCode]
      );
      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: (preferenceId) =>
          result[0].resultCode === declined_lead_next_level_multicart &&
          selectedPreference === "call-me-back"
            ? handlePrimaryNxtLvlClick(
                pageName,
                primaryLabel,
                result[0].leadType
              )
            : handlePrimaryClick(
                generateFormURL(
                  result[0].primaryCTAURL,
                  result[0].leadType,
                  result[0].primaryCTAType,
                  preferenceId
                ),
                pageName,
                result[0].primaryCTAText
              ),
        handleSecondaryClick: () =>
          handleSecondaryClick(
            generateFormURL(
              result[0].secondaryCTAURL,
              result[0].leadType,
              result[0].secondaryCTAType
            ),
            pageName,
            result[0].secondaryCTAText,
            resultCode
          ),
        imgUrl: result[0].icon,
        pageName: pageName,
        pageErrorType: pageErrorType,
        additionalUtagData: additionalUtagData,
        dividerLine: multicartFlag ? true : false,
        ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
        disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
        preferences: multicartFlag ? preferences : [],
        defaultPreference:
          multicartFlag && result[0].primaryCTAURL?.includes("/checkout")
            ? "once-off"
            : null,
      });

      Logger.error(
        result[0].resultTitle || "fetchErrorDetails - ConsentResultDetails - error",
        "ConsentResultDetails",
        {
          response: JSON.stringify(result),
          function: "fetchErrorDetails",
          functionParams: {
            resultCode,
            pageErrorType,
            additionalUtagData: JSON.stringify(additionalUtagData || {}),
            preferences: JSON.stringify(preferences || {})
          }
        }
      );

      setAnalyticsOnErrorPage(pageName, label);
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch (e) {

      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "fetchErrorDetails",
          multicartFlag
        }
      );

      if (multicartFlag) {
        setPageErr({
          type: "error",
          title: labels.checkout.lbl_invalid_attempt_title,
          desc: labels.checkout.lbl_invalid_attempt_desc,
          primaryLabel: "Continue",
          secondaryLabel: null,
          handlePrimaryClick: (preferenceId) =>
            handlePrimaryClick(
              generateFormURL(
                "/forms/ecommerce",
                "credit_vetting",
                "lead",
                preferenceId
              ),
              "continue"
            ),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
          pageErrorType: pageErrorType,
          additionalUtagData: additionalUtagData,
          dividerLine: true,
          ctaTitle: labels.checkout.lbl_select_preference,
          disablePrimary: true,
          preferences: labels.checkout.lbl_preference_values,
        });
      } else {
        setPageErr({
          type: "error",
          title: labels.auth.lbl_technical_error_title,
          desc: labels.auth.lbl_technical_error_desc,
          primaryLabel: "Call me back",
          secondaryLabel: "Exit checkout",
          handlePrimaryClick: () =>
            handlePrimaryClick(null, pageName, "Call me back", label),
          handleSecondaryClick: () =>
            handleSecondaryClick(null, pageName, "Exit checkout", label),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
        });
      }
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  const fetchCreditVettingErrorDetails = async (
    resultCode,
    errorCode,
    creditFiltersValue,
    pageErrorType,
    additionalUtagData = null,
    preferences = []
  ) => {
    let pageName, label;
    pageName = `checkout: credit check: ${customerStatus}: approved with conditions`;
    if (errorCode === labels.creditVetting.lbl_approved_with_condition) {
      label = "deal";
    }
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;
    try {
      showSpinner();
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [newResultCode]
      );

      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: (preferenceId = null) =>
          handlePrimaryClick(
            generateFormURL(
              result[0].primaryCTAURL,
              result[0].leadType,
              result[0].primaryCTAType,
              preferenceId
            ),
            errorCode,
            pageName,
            label,
            creditFiltersValue
          ),
        handleSecondaryClick: () =>
          handleSecondaryClick(
            generateFormURL(
              result[0].secondaryCTAURL,
              result[0].leadType,
              result[0].secondaryCTAType
            )
          ),
        imgUrl: result[0].icon,
        pageName: pageName,
        pageErrorType: pageErrorType,
        additionalUtagData: additionalUtagData,
        dividerLine: multicartFlag ? true : false,
        ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
        disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
        preferences: multicartFlag ? preferences : [],
        defaultPreference:
          multicartFlag && result[0].primaryCTAURL?.includes("/checkout")
            ? "once-off"
            : null,
      });
      setAnalyticsOnErrorPage(pageName, label);
      hideSpinner();
      navigate("pageError");
    } catch (e) {

      Logger.error(
        e,
        "ConsentResultDetails",
        {
          function: "fetchCreditVettingErrorDetails",
          multicartFlag
        }
      );

      if (multicartFlag) {
        setPageErr({
          type: "error",
          title: labels.creditVetting.lbl_invalid_attempt_title,
          desc: labels.creditVetting.lbl_invalid_attempt_desc,
          primaryLabel: "Continue",
          secondaryLabel: null,
          handlePrimaryClick: (preferenceId) =>
            handlePrimaryClick(
              generateFormURL(
                "/forms/ecommerce",
                "credit_vetting",
                "lead",
                preferenceId
              ),
              "continue"
            ),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
          pageErrorType: pageErrorType,
          additionalUtagData: additionalUtagData,
          dividerLine: true,
          ctaTitle: labels.checkout.lbl_select_preference,
          disablePrimary: true,
          preferences: labels.checkout.lbl_preference_values,
        });
      } else {
        setPageErr({
          type: "error",
          title: labels.auth.lbl_technical_error_title,
          desc: labels.auth.lbl_technical_error_desc,
          primaryLabel: "Call me back",
          secondaryLabel: "Exit checkout",
          handlePrimaryClick: () => handlePrimaryClick(),
          handleSecondaryClick: () => handleSecondaryClick(),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: `checkout: credit check: ${customerStatus}`,
        });
        hideSpinner();
        navigate("pageError");
      }
    }
  };

  /**
   * Get the next pre-populated next level form and submit it on behalf of the customer
   * @usage Redirect to Next level form
   */
  const handlePrimaryNxtLvlClick = async (pageName, label, leadType) => {
    showSpinner();
    const nexLvlFormPayload = {
      channel: "ONLINE",
      requestType: "next_level_cust",
      idNumber: authDetailsData?.idNumber ? authDetailsData?.idNumber : "",
      idDocType: "SAID",
      name: personalDetailsData?.firstName
        ? personalDetailsData?.firstName
        : "",
      surname: personalDetailsData?.surName ? personalDetailsData?.surName : "",
      msisdn: africaCountryCode(authDetailsData?.msisdn)
        ? authDetailsData?.msisdn
        : appendCountryCode(authDetailsData?.msisdn),
      emailAddress: contactDetailsData?.emailAddress,
    };
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });

    try {
      const formResponse = await microService.post(
        "api",
        "staticFormSubmit",
        nexLvlFormPayload,
        null,
        false
      );
      const formResult = formResponse.response?.data?.result;
      if (formResult?.successful) {
        const result = await leadSubmissonContent(
          labels.creditVetting.lbl_lead_submitted
        );
        setPageErr({
          type: "success",
          title: result[0].resultTitle,
          desc:
            result[0].resultText && result[0].resultText !== ""
              ? result[0].resultText
              : result[0].resultHTML,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          handlePrimaryClick: () =>
            handleSecondaryClick(result[0].primaryCTAURL, pageName, "exit"),
          imgUrl: result[0].icon,
          pageName,
        });
        hideSpinner();
        navigate("pageError");
      } else {
        if (formResponse?.error?.status) {
          fetchErrorDetails(
            `creditVettingOutcome_${formResponse?.error?.status}`,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        } else {
          fetchErrorDetails(
            labels.auth.errorCodes.api_time_out,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      }
    } catch (error) {

      Logger.error(
        error,
        "ConsentResultDetails",
        {
          function: "handlePrimaryNxtLvlClick"
        }
      );

      hideSpinner();
    } finally {
      removeCreditCheckStates(null);
    }
  };

  const handlePrimaryClick = async (
    url,
    errorCode,
    pageName,
    label,
    creditFiltersValue
  ) => {
    let maxPrice;
    if (errorCode === labels.creditVetting.lbl_approved_with_condition) {
      if (creditFilters?.total_monthly_payment) {
        maxPrice = creditFilters?.total_monthly_payment;
      } else {
        maxPrice = creditFiltersValue?.total_monthly_payment;
      }
    }
    showSpinner();
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });
    let navigateUrl = url === "/" ? url : `${urlPrefix}${url}`;
    if (url) {
      switch (errorCode) {
        case labels.creditVetting.lbl_approved_with_condition:
          if (multicartFlag) {
            if (url === "/deals") {
              router
                .push(
                  `${urlPrefix}${url}?monthly_recurring=minValue:0,maxValue:${maxPrice}&isShowQualifying=true`
                )
                .then(() => {
                  hideSpinner();
                });
            } else {
              router.push(navigateUrl).then(() => {
                hideSpinner();
              });
            }
          } else {
            router
              .push(
                `${urlPrefix}${url}?category=${dealCategoryId}&monthly_recurring=minValue:0,maxValue:${maxPrice}&isShowQualifying=true`
              )
              .then(() => {
                hideSpinner();
              });
          }
          break;
        default:
          if (navigateUrl === "/") {
            await deleteItemsFromCart(cartId, cartProductId);
          }
          router.push(navigateUrl).then(() => {
            hideSpinner();
          });
          break;
      }
    } else {
      router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
        hideSpinner();
      });
    }
  };

  /**
   * This function is triggered when the user clicks on the error page screen secondary button.
   *
   * @call clicks on "Exit/Exit checkout" button
   */
  const handleSecondaryClick = async (url, pageName, label) => {
    showSpinner();
    if (dealCartProduct) {
      await deleteItemsFromCart(cartId, cartProductId);
    }
    if (url) {
      router.push(`${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`/`).then(() => {
        hideSpinner();
      });
    }

    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
    });
    removeCreditCheckStates(null);
    dispatch({
      type: SET_CREDIT_VETTING_RESULT,
      payload: null,
    });
  };

  /**
   * Set the on Error page
   *
   * @call on error page load
   */
  const setAnalyticsOnErrorPage = (pageName, label) => {
    Analytics.view({
      page_event: "view",
      page_name: pageName,
      ...Analytics.getUtagData([
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
        "multicart_flag",
      ]),
    });
  };

  /**
   * Form submit request payload
   *
   * @usage map the key-value pair request
   */
  const mapFieldData = () => {
    let isIdTypeSaid = authDetailsData?.idType === "SAID";
    let isIdTypePassport = authDetailsData?.idType === "PASSPORT";
    return {
      individualDetails: {
        title: getTitle(personalDetailsData?.title),
        firstName: personalDetailsData?.firstName
          ? personalDetailsData.firstName
          : "",
        lastName: personalDetailsData?.surName
          ? personalDetailsData.surName
          : "",
        gender: personalDetailsData?.gender === "male" ? "M" : "F",
        maritalStatus: personalDetailsData?.maritalStatus
          ? personalDetailsData.maritalStatus
          : "",
        idType: authDetailsData?.idType,
        emailAddress: contactDetailsData?.emailAddress,
        birthDate: mmddyyyyDateFormat(
          personalDetailsData?.dob ? personalDetailsData.dob : ""
        ),
        cellphoneNumber: reStructuredPhoneNumber(),
        homephoneNumber: reStructuredPhoneNumber(),

        ...(isIdTypePassport && {
          passportNumber:
            authDetailsData?.idType === "PASSPORT"
              ? authDetailsData?.idNumber.toString()
              : "",
          passportCountryofIssue: titleCaseFirstLetterOfString(
            authDetailsData?.countryOrigin
              ? authDetailsData.countryOrigin.split("-")[0]
              : ""
          ),
          passportExpirationDate: mmddyyyyDateFormat(
            authDetailsData?.passportExpiry
              ? authDetailsData.passportExpiry
              : ""
          ),
        }),

        ...(isIdTypeSaid && {
          saIdNumber:
            authDetailsData?.idType === "SAID"
              ? authDetailsData?.idNumber.toString()
              : "",
          passportNumber: "",
          passportCountryofIssue: "",
          passportExpirationDate: "",
        }),
      },

      ricaAddress: {
        c3DSiebelAddressType: homeDetailsData?.addressType,
        streetNumber: homeDetailsData?.streetNo
          ? homeDetailsData.streetNo
          : "00",
        streetName: homeDetailsData?.streetName,
        suburb: homeDetailsData?.suburb,
        postalCode: homeDetailsData?.postalCode,
        deliveryAddressFlag: "N",
        cityTown: homeDetailsData?.town,
        province: homeDetailsData?.provinceName,
        periodAtCurrentAddressYears: homeDetailsData?.currentAddressYears
          ? homeDetailsData.currentAddressYears.replace(/\D/g, "")
          : "00",
        periodAtCurrentAddressMonths: homeDetailsData?.currentAddressMonths
          ? homeDetailsData.currentAddressMonths.replace(/\D/g, "")
          : "00",
        postalDeliveryFlag: "N",
        residence: homeDetailsData?.residence,
      },
      payment: {
        bankAccountDetails: {
          bankAccountName: "",
          bankAccountName:
            personalDetailsData?.firstName + " " + personalDetailsData?.surName,
          bankAccountType: debitDetailsData?.accountType,
          bankAccountNumber: debitDetailsData?.accountNumber,
          bankBranch: debitDetailsData?.branchName
            ? debitDetailsData.branchName
            : "Universal",
          bankName: debitDetailsData?.bank,
          billFrequency: "Monthly",
          billType: "Detailed Invoice",
          mediaType: "email PDF",
          paymentMethod: "Direct Debit",
          paymentType: "Postpaid",
          bankBranchCode: debitDetailsData?.branchCode
            ? debitDetailsData.branchCode
            : "",
          billFormat: "email PDF",
          ageOfAccountYears: debitDetailsData.ageOfAccountYears
            ? debitDetailsData.ageOfAccountYears.replace(/\D/g, "")
            : "00",
          ageOfAccountMonths: debitDetailsData.ageOfAccountMonths
            ? debitDetailsData.ageOfAccountMonths.replace(/\D/g, "")
            : "00",
          c3DBankValidationFlag: "Y",
          debitOrderCycle: "DIRECT DEBIT 1ST OF THE MONTH",
        },
        creditVettingDetails: {
          employerIndustry: employmentDetailsData?.empIndustry.toUpperCase(),
          employerName: employmentDetailsData?.employerName,
          employerNumber: employmentDetailsData?.employerNumber,
          frequencyOfSalary: "MONTHLY",
          grossMonthlyIncome: employmentDetailsData?.grossMonthlySalary
            ? reStructuredSalary(employmentDetailsData?.grossMonthlySalary)
            : "",
          occupationType: employmentDetailsData?.empCategory,
          periodatPreviousAddressYears: homeDetailsData?.previousAddressYears
            ? homeDetailsData.previousAddressYears.replace(/\D/g, "")
            : "00",
          periodatPreviousAddressMonths: homeDetailsData?.previousAddressMonths
            ? homeDetailsData.previousAddressMonths.replace(/\D/g, "")
            : "00",
          salaryDay: employmentDetailsData?.salaryDate,
          c3DEmploymentCategoryCode: employmentDetailsData?.employmentType,
        },
      },
    };
  };

  /**
   * Set the analytics(link)
   *
   * @call clicks on checkboxes
   */
  const setAnalyticsOnconsentcheck = (message) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: ` + message,
    });
  };

  /**
   * Set the analytics(link)
   *
   * @call clicks on "do credit check" button
   */
  const setAnalyticsOnDoCreditCheck = () => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: credit check`,
    });
  };

  return (
    <>
      <CustomContainer className={`${styles["container"]}`}>
        <>
          <CustomContainer className={styles["form-heading"]}>
            <img
              src={`${imagePrefix}/assets/images/like_section.svg`}
              alt="tick"
            />
            Credit check consent
            <CustomContainer className={styles["section-numbers"]}>
              {currentJourneyType != journeyType.addLine
                ? "Section 7 of 7"
                : "Section 5 of 5"}
            </CustomContainer>
          </CustomContainer>
          <hr></hr>
          {formContent && (
            <Form
              noValidate
              id="checkout-credit-check-consent-form"
              onSubmit={handleSubmit}
            >
              <ConsentResultsForm
                formName={type}
                fieldValues={state.fieldValues[type]}
                fieldErrors={state.fieldErrors[type]}
                fieldErrorsMessage={state.fieldErrorsMessage[type]}
                formContent={formContent ? formContent : ""}
                onChangeHandler={handleChange}
              />
              <CustomContainer className={styles["button-wrapper"]}>
                <CTAButton
                  type="submit"
                  variant="solid grey"
                  disabled={submitDisabled || !isDoCreditCheckDisable}
                  className={styles["button"]}
                  id="checkout-credit-check-consent-form-submit"
                  onClick={() => handleSubmit}
                >
                  Do credit check
                </CTAButton>
              </CustomContainer>
            </Form>
          )}
        </>
      </CustomContainer>
    </>
  );
};

ConsentResultDetails.propTypes = {
  userLoggedIn: PropTypes.bool,
  profileData: PropTypes.any,
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
  navigate: PropTypes.func,
  setShowDocsData: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    debitDetailsData: state.creditCheckDetails.debitDetails,
    personalDetailsData: state.creditCheckDetails.personalDetails,
    employmentDetailsData: state.creditCheckDetails.employmentDetails,
    contactDetailsData: state.creditCheckDetails.contactDetails,
    homeDetailsData: state.creditCheckDetails.homeDetails,
    deliveryDetailsData: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    creditFilters: state.upgrade.creditFilters,
    selectedUpgradeResponse: state.upgrade.selectedUpgradeResponse,
    cartProducts: state.cartDetails.cartProductItems,
    cartDetails: state.cartDetails,
    selectedPreference: state.checkoutPageError.selected_preference,
  };
};

const mapDispatchToProps = {
  removeCreditCheckStates,
  deleteItemsFromCart,
};

ConsentResultDetails.defaultProps = {
  type: "consentResultDetails",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConsentResultDetails);
